export default "__VITE_ASSET__BduwYx0O__"